module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Hummer-10283a448dd318b720c66c682b88bfdf.svg";